<template>
  <div class="host vm-form-array">
    <div class="vm-form-array-header">
      <h4>{{ scheme.name }}</h4>
      <button
        class="vm-add-button"
        type="button"
        @click="$emit('add', { data, scheme })"
      >
        Добавить
      </button>
    </div>
    <div class="vm-form-group-fields">
      <div
        class="vm-form-group-field"
        v-for="(item, index) in data"
        :key="index"
      >
        <button
          class="vm-remove-button"
          type="button"
          @click="$emit('remove', { data, index })"
        >
          Удалить
        </button>
        <FormArray
          v-if="Array.isArray(scheme.controls[0].controls)"
          @add="$emit('add', $event)"
          @remove="$emit('remove', $event)"
          :scheme="scheme.controls[0]"
          :options="options"
          :data="item"
        />
        <FormGroup
          v-else-if="typeof scheme.controls[0].controls !== 'undefined'"
          @add="$emit('add', $event)"
          @remove="$emit('remove', $event)"
          :scheme="scheme.controls[0]"
          :options="options"
          :data="item"
        />
        <FormControl
          v-else
          :control="scheme.controls[0]"
          :options="options"
          :data="item"
        />
      </div>
      <div v-if="!data.length" class="vm-empty-list">
        Список пуст
      </div>
    </div>
  </div>
</template>

<script>
import FormControl from './FormControl';

export default {
  name: 'FormArray',
  components: {
    FormGroup: () => import('./FormGroup'),
    FormControl
  },
  props: {
    scheme: Object,
    options: Object,
    data: Array
  },
  methods: {
    isControl(control) {
      return typeof control.controls === 'undefined';
    },
    isArray(control) {
      return Array.isArray(control.controls);
    }
  }
};
</script>

<style scoped>
.list-item {
  display: inline-block;
  margin-right: 10px;
}
.vm-form-array-header {
  display: flex;
  border: 1px solid #dfdfdf;
  height: 52px;
  align-items: center;
  border-radius: 6px 6px 0 0;
  padding: 1rem 2rem;
}
.vm-form-array-header h4 {
  margin: 0;
  font-size: 1rem;
  text-transform: uppercase;
}
.vm-form-array-header button {
  margin-left: auto;
}
.vm-form-group-fields {
  padding: 1rem 2rem 1rem 2rem;
  border: 1px solid #dfdfdf;
  border-top: 0;
  border-radius: 0 0 6px 6px;
}
.vm-form-group-field {
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.vm-form-group-field:last-child {
  margin-bottom: 0;
}
.vm-remove-button,
.vm-add-button {
  border: 0;
  outline: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  font-size: 12px;
  background-color: #41b883;
  color: #fff;
  text-transform: uppercase;
}
.vm-remove-button {
  background-color: #ff6a6a;
  margin-bottom: 0.5rem;
}
@media (max-width: 700px) {
  .vm-form-array-header {
    padding: 0.5rem 1rem;
  }
  .vm-form-group-fields {
    padding: 0.5rem 1rem 0.5rem 1rem;
  }
  .vm-form-group-field {
    margin-bottom: 0.5rem;
  }
}
</style>
